import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import i18next from 'i18next';
import React from 'react';

import { translateError } from '~src/services/translationServices';

import { ComponentWrapper, ErrorMsg, InputLabel, InputWrapper } from './selectInput.sc';

const { Option } = Select;

interface OwnProps {
  t: i18next.TFunction;
  label?: string;
  labelKey: string;
  optList: Array<Record<string, string>>;
  fontSize?: string;
  error?: string;
  textField?: string;
  valueField?: string;
  className?: string;
  optionRender?: (option: Record<string, string>, selectedValue: string) => React.ReactNode;
}

// TSFIX: prop [onFocus] are incommpatible between redux-form and antd [EventHandler<FocusEvent<any>> | (() => void)]
type Props = OwnProps & SelectProps<string>;

const SelectInput: React.FC<Props> = React.memo((props) => {
  const {
    fontSize = '.7rem',
    error,
    textField = 'name',
    valueField = 'value',
    value = '',
    labelKey,
    label = props.t(labelKey),
    notFoundContent,
    t,
    optList,
    className,
    optionRender,
    ...selectProps
  } = props;

  const selectedValue = value;

  return (
    <ComponentWrapper className={className}>
      <InputWrapper>
        <InputLabel
          data-translation={labelKey}
          className={`${!value ? 'empty' : ''} ${error ? 'invalid' : ''}`}
          $fontSize={fontSize}
        >
          {label}
        </InputLabel>
        <Select
          {...selectProps}
          options={
            !optionRender &&
            optList?.map((option) => {
              return {
                value: option.value,
                label: option.name,
              };
            })
          }
          value={value}
          notFoundContent={notFoundContent}
          className={error ? 'invalid' : ''}
          popupClassName="select-dd-styled"
        >
          {optList?.map((opt) => {
            const value = opt[valueField];
            const key = typeof value === 'string' ? value : JSON.stringify(value || 'default');

            if(optionRender) return optionRender(opt, selectedValue);
            
            return (
              <Option key={key} value={value} label={opt.name}>
                <div>{opt[textField]}</div>
              </Option>
            );
          })}
        </Select>
      </InputWrapper>
      {error && <ErrorMsg>{translateError(t, error)}</ErrorMsg>}
    </ComponentWrapper>
  );
});

export default SelectInput;
